import React from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";

import Logo from '../Components/Logo';
import Loading from '../Components/Loading';
import UnavailableSystem from '../Components/UnavailableSystem';

import styles from '../styles/Auth.module.css';

const RegistrationNew = () => {
    const [content, setContent] = React.useState('firstStep');

    const [email, setEmail] = React.useState('');
    const [isEmailValid, setIsEmailValid] = React.useState(true);
    const [verificationCode, setVerificationCode] = React.useState('');
    const [lastname, setLastname] = React.useState('');
    const [firstname, setFirstname] = React.useState('');
    const [surname, setSurname] = React.useState('');
    const [region, setregion] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [passwordConfirm, setPasswordConfirm] = React.useState('');
    const [status, setStatus] = React.useState('');
  
    const [dbStatus, setDbStatus] = React.useState('checking');
    const [loading, setLoading] = React.useState(true);
    const [loadingButton, setLoadingButton] = React.useState(false);

    React.useEffect(() => {
      const fetchData = async () => {
        try {
            const response = await axios.get('/api/health');
            if (response.status === 200) {
                setDbStatus('connected');
            }
        } catch (err) {
            setDbStatus('Отсутствует подключение к серверу');
        } finally {
            setLoading(false);
        }
    };
  
    fetchData();
    }, []);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
    const handleEmailChange = (e) => {
        const newEmail = e.target.value;
        setEmail(newEmail);
        setIsEmailValid(newEmail === '' || validateEmail(newEmail));
    };
  
    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        setLoadingButton(true);

        if (!isEmailValid) {
            setStatus('Введите корректный email.');
            setTimeout(() => {
                setStatus('');
            }, 2500);
            setLoadingButton(false);
        } else {
            if (email) {
                axios.post('/api/send-verification-code', { 
                    email 
                })
                .then(() => {
                    setContent('secondStep');
                })
                .catch((err) => {
                    setStatus(err.response?.data.message || err.message || 'Произошла ошибка');
                    console.log(err)
                })
                .finally(() => {
                    setLoadingButton(false);
                    setTimeout(() => {
                        setStatus('');
                    }, 2500);
                });
            } else {
                setStatus('Вы не ввели обязательные поля.');
                setTimeout(() => {
                    setStatus('');
                }, 2500);
                setLoadingButton(false);
            }
        }
    };
  
    const handleCodeSubmit = async (e) => {
        e.preventDefault();
        setLoadingButton(true);

        if (email && verificationCode) {
            axios.post('/api/verify-code', { 
                email, 
                verificationCode 
            }).then(() => {
                setContent('thirdStep');
            }).catch((err) => {
                setStatus(err.response?.data.message || err.message || 'Произошла ошибка');
            })
            .finally(() => {
                setLoadingButton(false);
                setTimeout(() => {
                    setStatus('');
                }, 2500);
            });
        } else {
            setStatus('Вы не ввели обязательные поля.');
            setTimeout(() => {
                setStatus('');
            }, 2500);
            setLoadingButton(false);
        }
    };
  
    const handleRegistrationSubmit = async (e) => {
        e.preventDefault();
        setLoadingButton(true);

        if (email && lastname && firstname && surname && region && password && passwordConfirm) {
            axios.post('/api/registration', {
            email,
            lastname,
            firstname,
            surname,
            region,
            password,
            passwordConfirm,
            })
            .then(response => {
                if (response.data.token) {
                    localStorage.setItem('token', response.data.token);
                    window.location.href = '/';
                } else {
                    setContent('fourthStep');
                    setStatus(response.data.message);
                }
            })
            .catch(err => {
                setStatus(err.response?.data.message || err.message || 'Произошла ошибка');
                setLoadingButton(false);
            })
            .finally(() => {
                setTimeout(() => {
                    setStatus('');
                }, 2500);
            })
        } else {
            setStatus('Вы не ввели обязательные поля.');
            setTimeout(() => {
                setStatus('');
            }, 2500);
            setLoadingButton(false);
        }
    };

    return (
        <>
        {loading ? (
            <Loading />
        ) : dbStatus === 'connected' ? (
            <>
                <div className={styles.indexMain}>
                    <div className={styles.lining}>
                        <div className={styles.leftSide}>
                            {content == 'firstStep' && 
                            <>
                                <span>
                                    <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                                        <Logo to='/' position='relative' />
                                        <Link to='/' className={styles.closeBtnContainerMobile}>
                                            <img src='/img/icons/close-x.svg' alt='X' />
                                        </Link>
                                    </div>
                                    <h1>Зарегистрируйте профиль в системе «Поток»</h1>
                                    <a>Введите адрес электронной почты</a>
                                    <input
                                        type='email'
                                        value={email}
                                        onChange={handleEmailChange}
                                        placeholder='Введите e-mail'
                                        style={{margin: '10px 0 0 0'}}
                                        minLength='3'
                                        maxLength='100'
                                        required
                                    />
                                    {!isEmailValid && <p className={styles.error}>Некорректный формат e-mail</p>}
                                    <p className={styles.infoBlock} style={{margin: '10px 0'}}>Необходимо ввести рабочий e-mail, поскольку Вы будете получать важные уведомления.</p>
                                </span>
                                <span>
                                    {status && (
                                        <a className={`${styles.statusPanel} ${styles.red}`}>
                                            <img src="/img/icons/error-icon.svg" alt="Ошибка" />
                                            {status}
                                        </a>
                                    )}
                                    {loadingButton ? 
                                        <Loading /> 
                                        : 
                                        <button className='button maxWidth' onClick={handleEmailSubmit}>Зарегистрироваться</button>
                                    }
                                    <a href='/privacy-policy' className={styles.explanation}>Продолжая, вы подтверждаете, что соглашаетесь с Пользовательским соглашением и политикой конфиденциальности.</a>
                                </span>
                            </>
                            }
                            {content == 'secondStep' &&
                            <>
                                <span>
                                    <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                                        <Logo to='/' position='relative' />
                                        <Link to='/' className={styles.closeBtnContainerMobile}>
                                            <img src='/img/icons/close-x.svg' alt='X' />
                                        </Link>
                                    </div>
                                    <div className={styles.headline}>
                                        <svg onClick={() => {setContent('firstStep')}} viewBox="0 0 24 24">
                                            <path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"></path>
                                        </svg>
                                        <h1>Введите код подтверждения</h1>
                                    </div>
                                    <a style={{color: '#919191', marginBottom: '10px'}}>На Вашу электронную почту отправлено письмо с 6-значным кодом</a>
                                    <a>Введите код</a>
                                    <input
                                        type='text'
                                        value={verificationCode}
                                        onChange={(e) => setVerificationCode(e.target.value)}
                                        placeholder='Введите 6-значный код'
                                        minLength='6'
                                        maxLength='6'
                                        required
                                    />
                                </span>
                                <span>
                                    {status && (
                                        <a className={`${styles.statusPanel} ${styles.red}`}>
                                            <img src="/img/icons/error-icon.svg" alt="Ошибка" />
                                            {status}
                                        </a>
                                    )}
                                    {loadingButton ? 
                                        <Loading /> 
                                        : 
                                        <button className='button maxWidth' onClick={handleCodeSubmit}>Подтвердить почту</button>
                                    }
                                    <a href='/privacy-policy' className={styles.explanation}>Продолжая, вы подтверждаете, что соглашаетесь с Пользовательским соглашением и политикой конфиденциальности.</a>
                                </span>
                            </>
                            }
                            {content == 'thirdStep' && 
                            <>
                                <span>
                                    <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                                        <Logo to='/' position='relative' />
                                        <Link to='/' className={styles.closeBtnContainerMobile}>
                                            <img src='/img/icons/close-x.svg' alt='X' />
                                        </Link>
                                    </div>
                                    <div className={styles.headline}>
                                        <svg onClick={() => {setContent('firstStep')}} viewBox="0 0 24 24">
                                            <path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"></path>
                                        </svg>
                                        <h1>Завершите регистрацию</h1>
                                    </div>
                                    <a>Введите фамилию</a>
                                    <input
                                        type='text'
                                        value={lastname}
                                        onChange={(e) => setLastname(e.target.value)}
                                        placeholder='Введите фамилию'
                                        minLength='3'
                                        maxLength='100'
                                        required
                                    />
                                    <a>Введите имя</a>
                                    <input
                                        type='text'
                                        value={firstname}
                                        onChange={(e) => setFirstname(e.target.value)}
                                        placeholder='Введите имя'
                                        minLength='4'
                                        maxLength='180'
                                        required
                                    />
                                    <a>Введите отчество</a>
                                    <input
                                        type='text'
                                        value={surname}
                                        onChange={(e) => setSurname(e.target.value)}
                                        placeholder='Введите отчество'
                                        minLength='4'
                                        maxLength='180'
                                        required
                                    />
                                    <a>Введите основной регион деятельности</a>
                                    <input
                                        type='text'
                                        value={region}
                                        onChange={(e) => setregion(e.target.value)}
                                        placeholder='Например, Нижегородская область'
                                        minLength='4'
                                        maxLength='180'
                                        required
                                    />
                                    <a>Введите пароль</a>
                                    <input
                                        type='text'
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder='Введите пароль'
                                        minLength='4'
                                        maxLength='180'
                                        required
                                    />
                                    <a>Повторите пароль</a>
                                    <input
                                        type='text'
                                        value={passwordConfirm}
                                        onChange={(e) => setPasswordConfirm(e.target.value)}
                                        placeholder='Введите пароль повторно'
                                        minLength='4'
                                        maxLength='180'
                                        required
                                    />
                                </span>
                                <span>
                                    {status && (
                                        <a className={`${styles.statusPanel} ${styles.red}`}>
                                            <img src="/img/icons/error-icon.svg" alt="Ошибка" />
                                            {status}
                                        </a>
                                    )}
                                    {loadingButton ? 
                                        <Loading /> 
                                        : 
                                        <button className='button maxWidth' onClick={handleRegistrationSubmit}>Завершить регистрацию</button>
                                    }
                                    <a href='/privacy-policy' className={styles.explanation}>Продолжая, вы подтверждаете, что соглашаетесь с Пользовательским соглашением и политикой конфиденциальности.</a>
                                </span>
                            </>
                            }
                            {content == 'fourthStep' &&
                            <>
                                <span>
                                    <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                                        <Logo to='/' position='relative' />
                                        <Link to='/' className={styles.closeBtnContainerMobile}>
                                            <img src='/img/icons/close-x.svg' alt='X' />
                                        </Link>
                                    </div>
                                    <h1>Вы успешно зарегистрированы в системе «Поток»</h1>
                                    <p className={styles.infoBlock} style={{margin: '10px 0'}}>Вы успешно зарегистрированы в системе «Поток».</p>
                                    <p className={styles.infoBlock} style={{margin: '10px 0'}}>После регистрации учётная запись проходит проверку, и доступ к системе может быть предоставлен в течение 3 рабочих дней. Оповещение будет отправлено на ваш адрес электронной почты</p>
                                </span>
                                <span>
                                </span>
                            </>
                            }
                        </div>

                        <div className={styles.rightSide}>
                            <Link to='/' className={styles.closeBtnContainer}>
                                <img src='/img/icons/close-x.svg' alt='X' />
                            </Link>
                            <span>
                                <div className={styles.additionalBtn}>
                                    <img src='/img/icons/signin.svg' alt='Вход' />
                                    <span>
                                        <h2>Уже есть учётная запись?</h2>
                                        <Link to='/auth/login'>Перейти к странице входа</Link>
                                    </span>
                                </div>
                                <div className={styles.additionalBtn}>
                                    <img src='/img/icons/comment-question.svg' alt='Поддержка' />
                                    <span>
                                        <h2>Возникла проблема?</h2>
                                        <Link to='/feedback'>Обратиться в поддержку</Link>
                                    </span>
                                </div>
                                <div className={styles.additionalBtn}>
                                    <img src='/img/icons/file-info-alt.svg' alt='Юридическая информация' />
                                    <span>
                                        <h2>Обратите внимание</h2>
                                        <Link to='/privacy-policy'>Пользовательское соглашение и политика конфиденциальности</Link>
                                    </span>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </>
        ) : (
            <UnavailableSystem dbStatus={dbStatus} />
        )}
        </>
    )
};

export default RegistrationNew;
